"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const IconWebsiteThemes = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  viewBox: "0 0 98 98"
}, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
  id: "je3blze1ma",
  width: "106.4%",
  height: "106.4%",
  x: "-3.2%",
  y: "-3.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/_react.default.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: "1"
}), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
})), /*#__PURE__*/_react.default.createElement("filter", {
  id: "pyo79btr4c",
  width: "128.8%",
  height: "142.2%",
  x: "-14.4%",
  y: "-21.1%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/_react.default.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: "2.5"
}), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
})), /*#__PURE__*/_react.default.createElement("filter", {
  id: "57rrdd8epe",
  width: "129.5%",
  height: "142.2%",
  x: "-14.7%",
  y: "-21.1%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/_react.default.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: "2.5"
}), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
})), /*#__PURE__*/_react.default.createElement("rect", {
  id: "6c5hvb5sub",
  width: "94",
  height: "94",
  x: "0",
  y: "0",
  rx: "23"
}), /*#__PURE__*/_react.default.createElement("rect", {
  id: "40bxoi6y6d",
  width: "52",
  height: "35.55",
  x: "4.908",
  y: "9.335",
  rx: "1.35"
}), /*#__PURE__*/_react.default.createElement("rect", {
  id: "4bda4yjhsf",
  width: "50.85",
  height: "35.55",
  x: "11",
  y: "18",
  rx: "1.35"
})), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
  transform: "translate(-363 -310) translate(365 312)"
}, /*#__PURE__*/_react.default.createElement("use", {
  fill: "#000",
  filter: "url(#je3blze1ma)",
  xlinkHref: "#6c5hvb5sub"
}), /*#__PURE__*/_react.default.createElement("use", {
  fill: "#5369F9",
  xlinkHref: "#6c5hvb5sub"
})), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
  transform: "translate(-363 -310) translate(365 312) translate(13 18) rotate(-22 30.908 27.11)"
}, /*#__PURE__*/_react.default.createElement("use", {
  fill: "#000",
  filter: "url(#pyo79btr4c)",
  xlinkHref: "#40bxoi6y6d"
}), /*#__PURE__*/_react.default.createElement("use", {
  fill: "#E3E8ED",
  xlinkHref: "#40bxoi6y6d"
})), /*#__PURE__*/_react.default.createElement("g", {
  transform: "translate(-363 -310) translate(365 312) translate(13 18)"
}, /*#__PURE__*/_react.default.createElement("use", {
  fill: "#000",
  filter: "url(#57rrdd8epe)",
  xlinkHref: "#4bda4yjhsf"
}), /*#__PURE__*/_react.default.createElement("use", {
  fill: "#F8F8F8",
  xlinkHref: "#4bda4yjhsf"
}))), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#ADB5BD",
  d: "M56.639 23.6c.96 0 1.8-.78 1.8-1.8s-.78-1.8-1.8-1.8-1.8.78-1.8 1.8.839 1.8 1.8 1.8zM50.639 23.6c.96 0 1.8-.78 1.8-1.8s-.78-1.8-1.8-1.8-1.8.78-1.8 1.8.839 1.8 1.8 1.8zM44.639 23.6c.96 0 1.8-.78 1.8-1.8s-.78-1.8-1.8-1.8-1.8.78-1.8 1.8.839 1.8 1.8 1.8zM15 20.3L30.9 20.3 30.9 22.7 15 22.7z",
  transform: "translate(-363 -310) translate(365 312) translate(13 18)"
}), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#285AFF",
  d: "M0 10.786L2.016 10.786 2.016 0 0 0zM26.006 10.786L28.022 10.786 28.022 0 26.006 0z",
  transform: "translate(-363 -310) translate(365 312) translate(13 18) translate(22 30)"
}), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#285AFF",
  d: "M21.307 6.363c.2.001.392-.025.578-.079.186-.054.35-.147.494-.28.143-.133.258-.306.345-.519.086-.212.13-.482.131-.809l.001-.327-1.585.246c-.248.039-.455.13-.622.272-.167.143-.252.359-.253.646 0 .218.075.414.226.587.152.174.38.262.685.263zm-2.81-.74c.001-.326.057-.616.168-.868.11-.252.26-.472.452-.66.19-.186.413-.334.665-.442.253-.108.527-.186.822-.234l1.729-.26c.2-.03.338-.09.415-.184.076-.094.115-.205.115-.334.001-.257-.096-.48-.29-.67-.194-.189-.491-.284-.891-.286-.42-.002-.74.116-.965.353-.225.236-.352.513-.382.83l-1.683-.379c.03-.287.116-.573.26-.86.144-.287.34-.543.589-.77.248-.227.553-.411.916-.553.362-.142.78-.212 1.257-.21.552.002 1.022.08 1.412.236.39.155.706.36.947.613.242.253.417.55.525.886.108.337.162.69.16 1.056l-.014 3.595c0 .198.008.408.026.631.018.223.037.4.055.528l-1.742-.008c-.018-.099-.034-.235-.048-.409-.014-.173-.02-.329-.02-.468-.182.287-.442.539-.78.755-.34.216-.77.323-1.294.321-.371-.001-.706-.065-1.006-.19-.299-.125-.553-.29-.762-.493-.208-.204-.367-.438-.475-.7-.109-.263-.162-.538-.161-.826zM8.22 4.822c-.1.257-.232.472-.394.645-.163.172-.354.303-.573.391-.22.088-.443.132-.672.13-.228 0-.451-.046-.67-.136-.218-.09-.408-.222-.57-.396-.16-.174-.29-.39-.39-.648-.098-.257-.147-.56-.146-.907.001-.346.053-.648.154-.905.1-.257.232-.472.395-.645.162-.172.353-.303.572-.39.22-.09.444-.133.672-.132.228.001.452.047.67.137.219.09.409.222.57.396.161.174.291.39.39.648.099.258.148.56.146.907-.001.346-.052.648-.153.905m1.79-2.426l-.01-.033c-.184-.476-.44-.885-.766-1.228C8.908.792 8.518.523 8.067.328 7.616.133 7.128.034 6.605.032 6.08.03 5.593.124 5.14.315c-.452.191-.844.457-1.173.797-.33.34-.589.748-.776 1.223-.188.474-.282.994-.285 1.559-.002.564.089 1.082.273 1.553.183.471.439.881.766 1.229.327.348.716.62 1.167.814.452.196.94.294 1.462.296.524.003 1.012-.092 1.465-.283.453-.191.844-.46 1.174-.805.33-.345.588-.752.776-1.222.004-.012.007-.025.012-.037-.136-.475-.204-.983-.202-1.516.002-.536.074-1.047.213-1.527M14.55 1.893c-.248-.001-.478.042-.693.13-.215.089-.403.22-.565.392-.163.172-.293.387-.389.644-.096.258-.144.55-.146.876-.001.327.045.62.14.877.094.258.224.477.39.656.165.178.355.313.57.403.213.09.443.135.691.137.238 0 .45-.035.636-.109.186-.073.345-.17.48-.288.133-.118.24-.251.322-.4.081-.148.141-.291.18-.43l1.668.587c-.077.307-.204.606-.382.897-.177.292-.404.553-.68.784-.278.232-.602.42-.974.561-.372.142-.791.212-1.257.21-.514-.002-.997-.1-1.448-.296-.451-.195-.843-.466-1.175-.814-.331-.348-.592-.758-.78-1.23-.189-.47-.282-.989-.28-1.553.003-.564.097-1.084.285-1.559.187-.474.446-.882.776-1.222.33-.34.716-.606 1.16-.797.443-.191.921-.286 1.435-.284.476.002.901.076 1.277.221.376.145.7.332.976.561.275.23.498.493.668.79.17.298.292.601.367.908l-1.7.587c-.085-.307-.248-.59-.49-.849-.242-.258-.596-.388-1.062-.39",
  transform: "translate(-363 -310) translate(365 312) translate(13 18) translate(22 30) translate(0 3.226)"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#FC0",
  d: "M0 13.608L27.74 13.608 27.74 11.632 0 11.632z",
  transform: "translate(-363 -310) translate(365 312) translate(13 18) translate(22 30) translate(0 3.226)"
}))))))));
const _default = IconWebsiteThemes;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(IconWebsiteThemes, "IconWebsiteThemes", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/IconWebsiteThemes.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/IconWebsiteThemes.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();